/**
 * Individual field validators
 */

import { isValidAge, resolveMinAge } from '../utils/dateHelpers.js';
import { t } from '../../i18n.js';

export function validateName(name) {
    if (!name || name.trim().length < 2) {
        return { valid: false, error: t('auth.error_name_min_length') };
    }
    return { valid: true };
}

export function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
        return { valid: false, error: t('auth.error_email_invalid') };
    }
    return { valid: true };
}

export function validateBirthday(day, month, year, minAge) {
    // Check for empty, null, undefined, or whitespace-only values
    const hasDay = day && String(day).trim() !== '';
    const hasMonth = month && String(month).trim() !== '';
    const hasYear = year && String(year).trim() !== '';

    if (!hasDay || !hasMonth || !hasYear) {
        return { valid: false, error: t('auth.error_birthday_incomplete') };
    }
    if (!isValidAge(day, month, year, minAge)) {
        return {
            valid: false,
            error: t('auth.error_age_requirement', { age: resolveMinAge(minAge) }),
        };
    }
    return { valid: true };
}

export function validateSex(sex) {
    if (!sex || (sex !== 'male' && sex !== 'female')) {
        return { valid: false, error: t('auth.error_sex_required') };
    }
    return { valid: true };
}

export function validateCity(cityId) {
    if (!cityId || cityId === '' || cityId === '0') {
        return { valid: false, error: t('auth.error_city_required') };
    }
    return { valid: true };
}

export function validateHomeCity(homeCityId) {
    if (!homeCityId || homeCityId === '' || homeCityId === '0') {
        return { valid: false, error: t('auth.error_home_city_required') };
    }
    return { valid: true };
}

export function validatePassword(password) {
    if (!password || password.length < 6) {
        return { valid: false, error: t('auth.error_password_min_length') };
    }
    return { valid: true };
}

export function validateUsername(username) {
    if (!username || username.trim().length < 2) {
        return { valid: false, error: t('auth.error_username_min_length') };
    }
    const usernameRegex = /^[a-zA-Z0-9_]+$/;
    if (!usernameRegex.test(username)) {
        return { valid: false, error: t('auth.error_username_format') };
    }
    return { valid: true };
}
